// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/track-correction-methods.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/track-correction-methods/track-correction-methods.js';

mount([g0]);
